/**
 * AUTO-GENERATED — DO NOT EDIT.
 * Source: sdk.manifest.yml + openapi.json.
 * Regenerate with: pnpm gen
 */

import { createHook } from '../../core/factories/createHook.js';

import { createPrefetchHook } from '../../core/factories/createPrefetchHook.js';
import type { GetPublicPartnerCreatorRow } from '../openapi-types.gen.js';
import { type useGetPublicPartnerCreatorArgs, useGetPublicPartnerCreatorSpec } from '../specs/creators.spec.gen.js';

export type { GetPublicPartnerCreatorRow } from '../openapi-types.gen.js';
export type { useGetPublicPartnerCreatorArgs } from '../specs/creators.spec.gen.js';


/**
 * Available query params (forwarded automatically; pass via the
 * hook's args): id.
 */
const _useGetPublicPartnerCreator = createHook(useGetPublicPartnerCreatorSpec);
export const useGetPublicPartnerCreator = _useGetPublicPartnerCreator as (args: useGetPublicPartnerCreatorArgs, opts?: import('../../core/factories/createHook.js').CreateHookCallOpts) => ReturnType<typeof _useGetPublicPartnerCreator>;


/**
 * Hover/intent prefetch companion for `useGetPublicPartnerCreator`. Returns a stable
 * `(args) => Promise<void>` callback that fires the real HTTP request
 * and writes the response into the SAME cache entry the reader hook
 * observes. The component owning the callback does NOT subscribe — no
 * re-renders on data, no NATS subscription. Idempotent: TanStack
 * `prefetchQuery` is a no-op when a fresh cache entry already exists.
 *
 *     function Link({ pubkey }) {
 *       const prefetch = usePrefetchGetPublicPartnerCreator();
 *       return (
 *         <a
 *           onMouseEnter={() => prefetch({ pubkey })}
 *           onFocus={() => prefetch({ pubkey })}
 *         >…</a>
 *       );
 *     }
 */
export const usePrefetchGetPublicPartnerCreator = createPrefetchHook(useGetPublicPartnerCreatorSpec) as () => import('../../types/SdkPrefetchTask.js').SdkPrefetcher<useGetPublicPartnerCreatorArgs>;
